import React from 'react';
import { CollapsibleDetailsSection } from '../../components';
import { TERMINAL_SOFTWARE_DETAILS } from '@shared/data/mockTerminalsPanels';

interface SoftwareSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  isDetailView?: boolean;
  className?: string;
}

export const SoftwareSection = React.memo<SoftwareSectionProps>(({ isExpanded, onToggle, isDetailView = false, className }) => {
  const handleCheckUpdate = () => {
    console.log('Check for updates clicked');
  };

  const actions = [
    {
      label: 'Check for Updates',
      onClick: handleCheckUpdate
    }
  ];

  return (
    <CollapsibleDetailsSection
      title="Software"
      details={TERMINAL_SOFTWARE_DETAILS}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isDetailView={isDetailView}
      emptyMessage="No software details available"
      actions={actions}
      className={className}
    />
  );
});

SoftwareSection.displayName = 'SoftwareSection';
